


<p-selectButton [(ngModel)]="value" [options]="options" [disabled]="disabled" [ngbTooltip]="getBoxTooltip()" (onOptionClick)="onOptionClick($event)" optionValue="value" optionLabel="icon">
  <ng-template let-item pTemplate>
    <div [ngbTooltip]="getItemTooltip(item)" class="btn w-full flex align-items-center justify-content-center ">
      <i *ngIf="item.icon" [class]="item.icon"></i>
      <span *ngIf="item.icon && item.label" class="mr-1"></span>
      <span *ngIf="item.label">
        {{ item.label | translate }}
      </span>
    </div>
  </ng-template>
</p-selectButton>
